export default {
	'tabs-title': {
		'detailed-sales-statement-for-an-item': 'Ürün satışları',
		'total-sales-to-a-customer': 'Müşteriye yapılan toplam satışlar',
		'total-sales': 'Toplam satış',
		'detailed-account-statement': 'Detaylı hesap özeti',
		'vat-statement': 'KDV Özeti'
	},
	item: 'Ürün',
	account: 'Hesap',
	'download-in-excel-format': 'Excel formunda indir'
}